import { render } from "./PanelEvent.vue?vue&type=template&id=586bb4f8"
import script from "./PanelEvent.vue?vue&type=script&lang=js"
export * from "./PanelEvent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__